import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUserGroupTeamAvailableUsers = (id, name) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  const queryParams = new URLSearchParams();
  if (name) queryParams.append('name', name);
  
  return useQuery({
    queryKey: [ id, 'UserGroupTeamAvailableUsers', name], 
    queryFn: async () => {
      const result = await restClient({
        url: `${prefix}/user-groups/${id}/team/available-users?${queryParams.toString()}`,
        method: 'get'
      });
      return result;
    },
    enabled:!!name && !!id, 
    staleTime: 0, 
    cacheTime: 0, 
    refetchOnWindowFocus: false
  });
};
